import {AnyAction, applyMiddleware, createStore} from "redux";
import {rootReducer} from "./root/rootReducer";
import thunk, {ThunkMiddleware} from 'redux-thunk';
import {RootState} from "./root/rootState";

export default createStore(rootReducer, applyMiddleware(thunk as ThunkMiddleware<RootState, AnyAction>));